import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../src/common/SafeIcon';

const { FiChevronDown, FiChevronUp } = FiIcons;

const FAQItem: React.FC<{ question: string; answer: string }> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-b border-slate-200 last:border-0">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center justify-between w-full py-6 text-left focus:outline-none">
        <span className="font-semibold text-slate-900 text-lg">{question}</span>
        <SafeIcon icon={isOpen ? FiChevronUp : FiChevronDown} className="w-5 h-5 text-slate-500" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'}`}>
        <p className="text-slate-600">{answer}</p>
      </div>
    </div>
  );
};

export const FAQ: React.FC = () => {
  const faqs = [
    { question: "Is this investment advice?", answer: "No. This course is educational and does not provide investment recommendations." },
    { question: "Does this cover ETFs?", answer: "Yes. We explain how crypto-related ETFs work at a practical level, along with custody and infrastructure concepts—without telling anyone what to buy." },
    { question: "Do I need a technical background?", answer: "No. Everything is explained in plain language, with advisor-friendly analogies." },
    { question: "How long is the mini-course?", answer: "Short and digestible. Most learners complete it in under an hour, with optional deeper resources." }
  ];
  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold text-slate-900">FAQ</h2>
        </div>
        <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100">
          {faqs.map((faq, idx) => (
            <FAQItem key={idx} {...faq} />
          ))}
        </div>
      </div>
    </section>
  );
};